export default __webpack_public_path__ + "static/media/placeholder-thread.be910105.svg";